import storage from 'redux-persist/lib/storage'
import { createTransform } from 'redux-persist'

import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2'

import { omit } from 'utils/lodash'

import { rootReducer } from './reducers'

type State = ReturnType<typeof rootReducer>

const BLACKLISTED_KEYS: string[] = []
const PERSISTED_KEYS: string[] = ['auth', 'user', 'kyc']

const PERSISTED_IGNORED_KEYS: Record<string, string[]> = {}

const blacklistTransformer = createTransform(null, (state: State, stateKey: string | number) => {
  if (PERSISTED_IGNORED_KEYS[stateKey]) {
    return omit(state, PERSISTED_IGNORED_KEYS[stateKey])
  }
  return state
})

// TODO: need check to change
const persistConfig = {
  key: 'We_Want_Justice_DAO_donations',
  storage,
  debug: true,
  version: 0.1,
  whitelist: PERSISTED_KEYS,
  blacklist: BLACKLISTED_KEYS,
  transforms: [blacklistTransformer],
  stateReconciler: autoMergeLevel2,
}

export { persistConfig }
